export default "__VITE_ASSET__f7701736__"